import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';
import { AuthProvider } from './sections/auth/AuthContext'

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
     <div
        style={{
          transform: "scale(0.9)",
          transformOrigin: "top left",
          width: "111.11%",   // 100 / 0.9 = 111.11% (important)
          minHeight: "100vh"
        }}
      >
    <ToastContainer position="top-right" autoClose={2000} />
      <AuthProvider>
        <ScrollTop>
        <RouterProvider router={router} />
      </ScrollTop>
      </AuthProvider>
      </div>
    </ThemeCustomization>
  );
}
